import { render, staticRenderFns } from "./bar.vue?vue&type=template&id=188e4cd6&scoped=true"
import script from "./bar.vue?vue&type=script&lang=ts"
export * from "./bar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188e4cd6",
  null
  
)

export default component.exports